<template>
  <div class="water-level">
    <table width="100%" class="TB_COLLAPSE">
      <thead>
        <tr class="tc">
          <th colspan="2" rowspan="2" style="z-index:2"></th>
          <th colspan="2">A盘赔率</th>
          <th colspan="2">B盘赔率</th>
          <th rowspan="2">最高赔率</th>
        </tr>
        <tr>
          <template v-for="i in 2">
            <th v-for="(it,idx) in titleSHeader" :key="`${i}-${idx}`">{{it}}</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(datait, dataidx) in waterLevelData" :key="dataidx">
          <th>{{datait.pmname}}</th>
          <th>
            <div
              v-for="(oddnameIt,oddnameIdx) in datait.item[0].oddname"
              :key="`${datait.pmid}-${datait.item[0].oddshigid[oddnameIdx]}`"
              :ref="`odd${datait.pmid}${oddnameIdx}`"
              class="water-level-list"
            >{{oddnameIt}}</div>
          </th>
          <template v-for="(ditIt, ditIdx) in datait.item">
            <td>
              <div
                v-if="datait.odds.length == 1"
                v-for="(oddsIt,oddsKey) in datait.odds[0]['item'][ditIdx]"
                :key="oddsKey"
              >
                <div v-if="oddsKey === 'odds'">
                  <p
                    :ref="`odd${datait.pmid}${oddvalIdx}`"
                    v-for="(oddval,oddvalIdx) in oddsIt"
                    :key="oddvalIdx"
                    class="water-level-list"
                  >
                    <Input
                      :class="`odd${oddvalIdx}`"
                      v-model="oddsIt[oddvalIdx]"
                      class="water-level-input"
                      @on-change="change(datait.odds[0]['item'][ditIdx].id[oddvalIdx],oddsIt[oddvalIdx],1)"
                    ></Input>
                  </p>
                </div>
              </div>
              <template v-if="datait.odds.length > 1">
                <template v-for="num in datait.odds[0].item[ditIdx].odds.length">
                  <p :ref="`odd${datait.pmid}${num-1}`" class="water-level-list" :key="num">
                    <Input
                      v-model="datait.odds[0].item[ditIdx].odds[num-1]"
                      class="water-level-input"
                      @on-change="change(datait.odds[0].item[ditIdx].id[num-1],datait.odds[0].item[ditIdx].odds[num-1],1)"
                    ></Input>
                    <span v-if="datait.odds[1].item[ditIdx].odds[num-1] != undefined">
                      /
                      <Input
                        v-model="datait.odds[1].item[ditIdx].odds[num-1]"
                        class="water-level-input"
                        @on-change="change(datait.odds[1].item[ditIdx].id[num-1],datait.odds[1].item[ditIdx].odds[num-1],1)"
                      ></Input>
                    </span>
                  </p>
                </template>
              </template>
            </td>
            <td>
              <Input
                v-model="ditIt.pcomis"
                @on-change="change(datait.pmid,ditIt.pcomis,2,ditIdx)"
                class="water-level-input"
              ></Input>
            </td>
          </template>
          <td>
            <div
              v-for="(oddshigIt,oddshigIdx) in datait.item[0].oddshig"
              :key="`${datait.pmid}-${datait.item[0].oddshigid[oddshigIdx]}`"
              class="water-level-list"
            >
              <Input
                v-model="datait.item[0].oddshig[oddshigIdx]"
                @on-change="change(datait.item[0].oddshigid[oddshigIdx],datait.item[0].oddshig[oddshigIdx],3)"
                class="water-level-input"
              ></Input>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <Row type="flex" align="middle" justify="center" class="mt-4 mb-2">
      <Button type="error" size="large" @click="modify">储存</Button>
    </Row>
  </div>
</template>

<script>
import NP from 'number-precision'
import { Utile } from 'utils'
import { mapGetters } from 'vuex';
export default {
  name: 'water-level',
  data () {
    return {
      waterLevelData: [],
      titleSHeader: ['赔率', '退水(%)'],
      color_th: ['特码半波单双单', '特码半波单双雙', '特码半波大小大', '特码半波大小小', '特码颜色'],
      itemspcomis: [],
      itemsodd: [],
      itemsoddshi: [],
    }
  },
  computed: {
    ...mapGetters(['getmember', 'getgameid']),
    wlsge_data () {
      return this.waterLevelData.filter(it => it.odds[0].rep < 65 || it.odds[0].rep > 79)
    },
    wlsgeco_data () {
      return Utile.chunk(this.waterLevelData.filter(it => it.odds[0].rep >= 65 && it.odds[0].rep <= 79), 3)
    }
  },
  watch: {
    getgameid () {
      this.wlsge();
    }
  },
  created () {
    this.wlsge();
  },
  methods: {
    async wlsge () { // 取得退水參數
      try {
        const res = await this.$axios.setting.getWaterLevel(this.getgameid)
        if ('status' in res && res.status === 0) return
        this.waterLevelData = res.data.filter(it => it.pmid !== 6).map(it => {
          it.item.forEach(itemit => {
            itemit.pcomis = NP.times(itemit.pcomis, 100).toFixed(2)
          })
          return it
        })
      } catch (error) {
        console.error(error);
      }
    },
    async modify () { // 修改退水
      if (this.CheckArray(this.itemsodd) || this.CheckArray(this.itemsoddshi)) return this.$Message.error({ content: '赔率不可低于 1' })
      if (this.CheckItemspcomis()) return this.$Message.error({ content: '退水不可低于 0' })
      if (this.CheckSymbol()) return this.$Message.error({ content: '请输入数字格式' })
      if ([this.itemsodd.length, this.itemsoddshi.length, this.itemspcomis.length].every(it => it == 0)) return this.$Message.error({ content: '无修改' })
      try {
        const obj = {
          loid: this.getmember.pid,
          itemsodd: this.itemsodd,
          itemsoddshi: this.itemsoddshi,
          itemspcomis: this.itemspcomis
        }
        const res = await this.$axios.setting.modifyWaterLevel(this.getgameid, obj)
        if (!res) return this.$Message.error({ content: '未更改数值' })
        if (res.status !== 1) return this.$Message.error("修改失败")
        this.wlsge()
        this.$Modal.success({
          render: (h) => {
            let texts = res.seok.split('\n')
            return h('div', texts.map(it => {
              return h('p', it)
            }))
          },
        })
        this.itemsodd = []
        this.itemsoddshi = []
        this.itemspcomis = []
      } catch (error) {
        console.error(error);
        this.$Message.error("栏位异常");
      }
    },
    change (id, newsvalue, status, pcomisSet = -1) {
      if (status == 1) this.filterChange(this.itemsodd, { id, newsvalue: Number(newsvalue) }, status)
      if (status == 2) this.filterChange(this.itemspcomis, { newsvalue: parseFloat(newsvalue), pmid: id, opid: pcomisSet + 4 }, status)
      if (status == 3) this.filterChange(this.itemsoddshi, { id, newsvalue: parseFloat(newsvalue) }, status)
    },
    filterChange (oarr, obj, status) {
      if (oarr.length < 1) {
        oarr.push(obj)
      } else {
        if (status != 2) {
          oarr.forEach((it, idx) => {
            if (it.id === obj.id) {
              oarr.splice(idx, 1)
            }
          })
        }
        if (status == 2) {
          oarr.forEach((it, idx) => {
            if (it.opid === obj.opid && it.pmid === obj.pmid) {
              oarr.splice(idx, 1)
            }
          })
        }
        oarr.push(obj)
      }
    },
    CheckArray (_Array) { // 判斷倍率 不可小於 1
      if (!_Array.length) return
      const result = _Array.some(it => it.newsvalue < 1)
      return result
    },
    CheckItemspcomis () { // 判斷退水 不可低於 0
      if (!this.itemspcomis.length) return
      const result = this.itemspcomis.some(it => it.newsvalue < 0)
      return result
    },
    CheckSymbol () { // 判斷是否填入特殊符號, 並且 newsvalue 為 NaN
      let result = false
      const ArrayKey = ['itemsodd', 'itemsoddshi', 'itemspcomis']
      for (let index = 0, len = ArrayKey.length; index < len; index++) {
        const element = ArrayKey[index];
        if (!this[element].length) continue;
        result = this[element].some(it => isNaN(it.newsvalue))
        if (result) break;
      }
      return result
    }
  }
}
</script>
<style lang="scss">
.water-level {
  &-input {
    width: 80px;
  }
  div.water-level-list {
    line-height: 24px;
  }
  &-list {
    margin-bottom: 2px;
    min-height: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>